import React from "react";
import { Link } from "react-router-dom";

const EmptyState = ({ icon: Icon, title, message, ctaLabel, ctaTo, testId }) => (
  <div
    className="flex flex-col items-center justify-center text-center py-20 px-6"
    data-testid={testId}
  >
    {Icon && (
      <div className="mb-6 flex h-16 w-16 items-center justify-center border border-ink">
        <Icon size={28} strokeWidth={1.5} />
      </div>
    )}
    <h3 className="font-display text-4xl uppercase tracking-tight">{title}</h3>
    {message && (
      <p className="mt-3 max-w-sm text-sm text-ink/60">{message}</p>
    )}
    {ctaLabel && ctaTo && (
      <Link to={ctaTo} className="btn-solid mt-8" data-testid="empty-state-cta">
        {ctaLabel}
      </Link>
    )}
  </div>
);

export default EmptyState;
